import React from "react";

const UrlKeyError = () => (
  <div className="error-container">
    <h1 className="error-header">{"404."}</h1>
    <div className="error-content">
      <h3>{"The page you were looking for does not exist."}</h3>
      <p>{"You may have mistyped the address or the page may have moved."}</p>
      <p>
        {
          "If you are the application owner check the logs for more\
          information."
        }
      </p>
    </div>
  </div>
);

export default UrlKeyError;



// WEBPACK FOOTER //
// ./src/components/UrlKeyError.js